import React, { useContext } from 'react';
import strings from 'common/strings';
import { getFormattedDurationFromSeconds } from 'utils/time';
import VehicleCardSkeleton from './VehicleCardSkeleton';
import { VehicleCardContext } from '../VehicleCard';

interface VehicleTimesTableProps {
  isRecon?: boolean;
  position?: number;
}

var VehicleTimesTable = ({ isRecon, position }: VehicleTimesTableProps) => {
  const { vehicle } = useContext(VehicleCardContext);
  if (!isRecon || !vehicle) {
    return null;
  }
  return (
    <VehicleCardSkeleton renderSkeleton={!vehicle}>
      <div className="VehicleCard-detail-item">
        <div className="VehicleCard-label mr-2">
          {strings.RECON_TIME.toUpperCase()}
        </div>
        <div
          className="VehicleCard-value"
          id={`vehicle-card-recon-time-${position}`}
        >
          {vehicle?.reconTimeAsSeconds
            ? getFormattedDurationFromSeconds(vehicle?.reconTimeAsSeconds || 0)
            : strings.EMPTY_VALUE}
        </div>
      </div>
      <div className="VehicleCard-detail-item">
        <div className="VehicleCard-label mr-2">{strings.RETAIL_READY}</div>
        <div
          className="VehicleCard-value"
          id={`vehicle-card-retail-time-${position}`}
        >
          {vehicle.retailReadyTimeAsSeconds
            ? getFormattedDurationFromSeconds(
                vehicle.retailReadyTimeAsSeconds || 0
              )
            : strings.EMPTY_VALUE}
        </div>
      </div>
    </VehicleCardSkeleton>
  );
};

export default VehicleTimesTable;
